// extracted by mini-css-extract-plugin
export default {"button":"QuestionMarkButton_button__fk1S5"};